define('controllers/modules/onboarding/onboarding',[
    // parent
    'src/controller/controller',
    // services
    'services/user',
    // collections
    'collections/member/supervisors',
    // views
    'views/modules/onboarding/onboarding'
], function(
    // parent
    Controller,
    // services
    User,
    // collection
    Supervisors,
    // views
    VOnboarding
) {

    var OnboardingCtrl = Controller.extend({
        authDefault: true,
        routes: {
            '*noclient': 'index',
        },

        ////////////
        // routes //
        ////////////

        index: function(groupId) {
            var onboardingView = new VOnboarding();
            var layout = this.getLayout();

            this.when(
                layout.setGroupId(groupId),
                layout.getUnreadConversations(),
                User.fetch(),
                Supervisors.fetch(),
            ).then(function() {
                this.getLayout().getContent().setView(onboardingView, true);
            });
        },

        onBack: function() {
            this.trigger('back');
        },

    });

    return OnboardingCtrl;
});

